import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'], // Corrected: `styleUrl` -> `styleUrls`
})
export class SuccessComponent {
  @Input() tipo: string = 'success';
  @Input() mensaje: string = 'Tu recarga ha sido exitosa';
}
